<template>
  <div>
    <label class="typo__label" :for="id" v-if="label">{{ label }}{{ isRequired ? '*' : '' }}</label>
    <input
      v-bind="$attrs"
      :id="id"
      :type="type"
      class="control control--input"
      v-model="inputValue"
      :placeholder="placeholder"
      :class="{ 'is-error': error, inputClassName }"
      @input="handleInput"
      :disabled="disabled"
      @blur="$emit('onBlur', inputValue)"
      @focus="$emit('onFocus')"
    />
    <p v-if="error" class="error-message">{{ error }}</p>
  </div>
</template>

<script>
import { emojiRegexp } from '../../mixins'

export default {
  name: 'Input',
  props: {
    type: {
      type: String,
      default: 'text'
    },
    id: String,
    error: String,
    label: String,
    emojiValidation: Boolean,
    isRequired: Boolean,
    placeholder: String,
    inputClassName: String,
    value: String,
    regexp: RegExp,
    maxLength: Number,
    disabled: Boolean
  },
  mixins: [emojiRegexp],
  data () {
    return {
      inputValue: ''
    }
  },
  methods: {
    handleInput (e) {
      let filteredValue = e.target.value

      if (this.emojiValidation) {
        filteredValue = filteredValue.replace(this.emojiRegexp, '')
      }

      if (this.regexp) {
        filteredValue = this.regexpReplace(filteredValue)
      }

      if (this.maxLength) {
        filteredValue = filteredValue.substr(0, this.maxLength)
      }

      this.inputValue = filteredValue
      this.$emit('input', filteredValue)
    },
    regexpReplace (value) {
      return value.replace(this.regexp, '')
    },
    blur () {
      this.$refs.customInput.blur()
    }
  },
  watch: {
    value (value) {
      this.inputValue = value
    }
  },
  mounted () {
    if (this.value) {
      this.inputValue = this.value
    }
  }
}
</script>

<style lang="sass" scoped>

.user-logged-form__semi-item--egr
  .control
    margin-bottom: 0

  .error-message
    position: absolute
    bottom: -15px

.subscribe-form__input-wrap .control
  margin: 0
  background: #363637
  color: $white-text-color
  border-color: transparent
  padding: 0 12px
  width: 100%
  max-width: 300px

  +mmax(768)
    max-width: 100%

.error-message
  margin: 0 0 0 9px

.subscribe-form__input-wrap .is-error,
.video-input__input-wrap .is-error,
.contact-form__input .is-error
  border-color: $nd-error-text-color
</style>
